import { render, staticRenderFns } from "./IndexOrderPage.vue?vue&type=template&id=758b7848&"
import script from "./IndexOrderPage.vue?vue&type=script&lang=js&"
export * from "./IndexOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports